<template>
    <div>
	<el-container>
	  <el-header class="homeHeader">
		  
		  <div class="title"><img src="../assets/HWQT.gif" alt=""> 水质在线监测信息系统</div>
		  <el-dropdown class="userInfo" @command="commandHandler">
		    <span class="el-dropdown-link" style="font-family: 微软雅黑; color: #FFFFFF;">
		      {{user.username}}<i class="el-icon-arrow-down el-icon--right"></i>
		    </span>
		    <el-dropdown-menu slot="dropdown">
			  <el-dropdown-item command="home">地图</el-dropdown-item>
			  <el-dropdown-item command="dataDis">数据展示</el-dropdown-item>
		      <el-dropdown-item command="userinfo">系统配置</el-dropdown-item>
	
		      <el-dropdown-item command="logout" divided>注销登陆</el-dropdown-item>
		    </el-dropdown-menu>
		  </el-dropdown>

	  </el-header>
	  <el-container >
	    <el-aside v-if="this.$router.currentRoute.path!='/home'" width="200px" height="100%" >
			<el-menu :default-active="activeNav" router v-if="this.$router.currentRoute.path=='/data/datadis'" ><!-- @select="menuClick"> -->
			      <el-menu-item :index="item.id+''" @click="updateDian(item.id,item.dianName)" v-for="(item,key) in sitesFun" :key="key" class="aside">
			             <i class="el-icon-s-home" style="color: #ffaa00;" v-if="item.status==4"></i>
			             <i class="el-icon-s-home" style="color: green;" v-if="item.status==1"></i>
						 <i class="el-icon-s-home" style="color: black;" v-if="item.status==2"></i>
						 <i class="el-icon-s-home" style="color: red;" v-if="item.status==3"></i>
						 <span slot="title">{{item.dianName}}</span>
			     </el-menu-item>		
				<!-- <DataDis v-bind:siteId="siteId"></DataDis> -->
			</el-menu>
			<el-menu :default-active="activeM" router v-if="this.$router.currentRoute.path!='/data/datadis'" ><!-- @select="menuClick"> -->
			      <el-submenu :index="index+''" v-for="(item,index) in routes" v-if="!item.hidden" :key="index" class="aside">
			        <template slot="title">
			          <i style="color: #87CEFA; margin-right: 5px;" :class="item.iconCls"></i>
			          <span>{{item.name}}</span>
			        </template>			        
			        <el-menu-item :index="child.path" v-for="(child,indexj) in item.children" :key="indexj" class="twoitem">
						<i style="color: #87CEFA; margin-right: 5px; margin-left: 50px;" :class="child.iconCls"></i>
						{{child.name}}
					</el-menu-item>
			      </el-submenu>		      
			</el-menu>
		</el-aside>
	    <el-main>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="this.$router.currentRoute.path!='/home'">
			    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			    <el-breadcrumb-item>{{this.$router.currentRoute.name}}</el-breadcrumb-item>
			</el-breadcrumb>
			
			<div  v-if="this.$router.currentRoute.path=='/home'" separator-class="el-icon-arrow-right">		
				<!-- <el-breadcrumb separator-class="el-icon-arrow-right">
				 <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
				 </el-breadcrumb> -->
				  <baidu-map  :zoom="zoom" @ready="handler" :style="{height:mapHeight}" :scroll-wheel-zoom='true'>
				  </baidu-map>
			</div>
			
			<router-view class="homeRouterView"/>
		</el-main>
	  </el-container>
	</el-container>
    </div>
</template>

<script>
	 // import screenfull from 'screenfull'
	   import BMap from 'vue-baidu-map'
	  import Vue from 'vue'
	  import siteMarker from '../assets/site-marker-red-48.png'
	  import redAdrr from '../assets/redAdrr.png'
	  import blackAdrr from '../assets/blackAdrr.png'
	  import greenAdrr from '../assets/greenAdrr.png'
	  import orgAdrr from '../assets/orgAdrr.png'
	  import blueAdrr from '../assets/blueAdrr.png'
	  import JsonExcel from 'vue-json-excel'
	  import {timerSite} from '../utils/sites.js'
	  Vue.use(BMap, {
	  	    ak: '9iXpnbjBEHLThGKjPrUXRwuGzllUEn4n'//'YWkzO92rbm7duOiIx13KSE3EE7siEXiG'
	  })
	  /* import DataDis from './data/DataDis.vue' */
 export default{
 	name:"Home",
	// provide(){
	// 	siteId:this.$data.siteId
	// },
	// components:{
	// 	DataDis
	// },
	// created(){
		
	// 	this.$router.push('/sys/pw');
	// },
	mounted() {
		
		//
		//window.open('#/emp/adv', '_blank');
		//else
		//if(sessionStorage.getItem('flag')==0||sessionStorage.path=='/home'){
			
		//}
		//if(sessionStorage.path=='/home')
		
		//this.handler()
		//this.activeN();
		//if(sessionStorage.path.indexOf('sys')!=-1)
	
		window.onresize = () => {
			
			var thish=this;
			return (() => {
				thish.$data.mapHeight = (window.innerHeight-130) + 'px';
				////console.log(thish.$data.mapHeight);
			})();
		};
		////console.log(this.$data.mapHeight);
	   // this.initEmps();
		
	    
	},
	
	beforeUpdate() {
		
		// //console.log(this.$store.state.routes)
		// if(sessionStorage.getItem('flag')==1){
		// 	sessionStorage.setItem('flag',0)
		// 	if(sessionStorage.path=="/home"||sessionStorage.path=="null")
		// 		this.play=true
		// 	else{
		// 		this.play=false
		// 		this.$router.replace(sessionStorage.path)
		// 	}
			
		//  }
		//  else{
		// 	if(sessionStorage.path=="/home"||sessionStorage.path=="null"
		// 	||sessionStorage.path==undefined)
		// 		this.play=true
		// 	// 	//sessionStorage.path='/home';
		// 	 }
		
	},
	created(){
		
		//sessionStorage.setItem("timeId",timerSite(this.$store));
		if(sessionStorage.getItem("flag")==1){
			sessionStorage.setItem('flag',0)
			let path=sessionStorage.getItem('path');
			if(path==null)
			this.$router.push('/home');
			else if(path.indexOf("sys")!=-1){
				//clearTimeout(sessionStorage.getItem('timeId'));
				//sessionStorage.setItem("timeId",null)
				this.$router.push('/sys/syspw');
			}
			else if(path.indexOf("dis")!=-1){
				this.$router.push('/data/datadis');
			}
			
		}
		
		
	},
	data(){
		return{
			user: JSON.parse(window.sessionStorage.getItem("user")),
			editableTabsValue: '0',
			editableTabs: [],
			tabIndex: 0,
			realData: [],
			timeId:'',
			play:false,
			 center: null,
			 zoom: 13,
			 PreviousPoint:null,
			 map:null,
			 BMap:null,
			 infor:[],
			 points:[],
			 pointStatus:[],
			 myIcon:null,
			 mapHeight:(window.innerHeight-130)+'px',
			 sites:this.$store.state.sites,
			 siteId:'',
			 activeNav:'',
			 activeM:'/sys/pw'
			     
		  }
		  
	},
	computed:{
		
		routes() {
			//console.log("hachlog:"+this.$store.state.routes);
			
		    return this.$store.state.routes;
		},
		sitesFun(){
			//this.$data.activeNav=this.$store.state.sites[0].id;
			
			this.activeN();
			return this.$store.state.sites;
		}
		
	},
	 beforeDestroy() {
	 	//debugger
	 	clearTimeout(this.timeId);
		clearTimeout(sessionStorage.getItem('timeId'));
		sessionStorage.setItem("timeId","null");
	 },
	methods:{
		activeN(){
			this.$data.activeNav=this.$store.state.siteId+''
		},
		updateDian(id,name){
			
			this.$data.siteId=id;
			this.$store.commit('initSiteId',id);
			this.$store.commit('initSiteName',name);
			this.$router.replace('/data/datadis');
			//this.$router.replace({ path: '/data/datadis', query: { siteId: id }})
			
			
		},
		translateCallback  (data){
		    	
		    	
		      if(data.status === 0) {
		        for (var i = 0; i < data.points.length; i++) {
		        	  // 创建信息窗口对象，引号里可以书写任意的html语句。obj[x].GateName\obj[x].Longitude\obj[x].Latitude
		          //  var infoWindow = new BMap.InfoWindow
		           /*    var infoWindow=   "<table class=‘mytable‘  border=‘0‘ cellspacing=‘0‘ cellpadding=‘0‘>"
		                + "<tr><td>站点名称：杭州哈希环境科技有限公司"+i 
		                + "</td></tr><tr><td>经度：" 
		                + "</td></tr><tr><td>纬度：" 
		                + "</td></tr></table>";
		        	//var marker=new BMap.Marker(data.points[i],{icon:myIcon});*/
					if(this.pointStatus[i]==4){
						this.$data.myIcon.setImageUrl(orgAdrr);
					}else if(this.pointStatus[i]==2){
						this.$data.myIcon.setImageUrl(blackAdrr);
					}
					else if(this.pointStatus[i]==1){
						this.$data.myIcon.setImageUrl(blueAdrr);
					}
					else if(this.pointStatus[i]==3){
						this.$data.myIcon.setImageUrl(redAdrr);
					}
		        	var marker=this.createMarker(data.points[i],this.$data.infor[i]);
		            this.$data.map.addOverlay(marker);  
		           /* var label = new BMap.Label("杭州哈希环境科技"+i,{offset:new BMap.Size(-40,-20)});
		            marker.setLabel(label); //添加百度label? */
		           
		            //bm.addOverlay(new BMap.Marker(data.points[i]));
		            this.$data.map.setCenter(data.points[i]);
		            
		        }
		      }
			  this.timeId=this.TimerMap();
		    },
		createMarker(point,info_html){
			var that=this;
			var markerx = new that.$data.BMap.Marker(point,{icon:this.$data.myIcon});
			markerx.addEventListener("mouseover",function(e){
				this.openInfoWindow(new that.$data.BMap.InfoWindow(info_html));
			});
			markerx.addEventListener("mouseout",function(e){
				this.closeInfoWindow(new that.$data.BMap.InfoWindow(info_html));
			}); 
			markerx.addEventListener("click",function(e){
				 
					if (that.$data.PreviousPoint!=null) {
						//如果上一个坐标不为空，移除跳动动作，null为移除
						that.$data.PreviousPoint.setAnimation(null);
					}
				   // 记录当前点击的坐标
				   that.$data.PreviousPoint = this;
					//当前左边开始跳动
					this.setAnimation(BMAP_ANIMATION_BOUNCE);
					//自己定义的打开信息窗口，没什么用
				   // openInfo(content, e)
			});
			return markerx;
		},
		handler ({BMap, map}) {
			  //var PreviousPoint=null;
			  //var infor=[],points=[];
			  var that=this;
			  this.$data.BMap=BMap;
			  this.$data.map=map;
			  this.$data.myIcon = new BMap.Icon(siteMarker, new BMap.Size(48, 48), {
			  	 	  imageSize: {
			  	        height: 30,
			  	        width: 30
			  	      },
			  	      anchor: {width: 15, height: 30}
			       })
			  this.getRequest('/data/real/getDianIfor').then(resp => {
			  		var json=resp.data;
					var pointsUp=[];
					if(json.length==0){
						this.$message({
						  type: 'info',//success/warning/info/error/;
						  message: "无符合条件的数据。"
						}); 
						//alert("无符合条件的数据。");
						
						
					}else{
						
						
						//bm=new BMap.Map("allmap");
						//convertor=new BMap.Convertor();
						this.$data.pointStatus=[];
						for(var i=0;i<json.length;i++){
							
							if(json[i]["longitude"]!=null&&json[i]["latitude"]!=null)	{
								pointsUp.push(new BMap.Point(json[i]["longitude"],json[i]["latitude"]));
								this.$data.pointStatus.push(json[i]["status"]);
								var infoWindow=   "<el-card class='box-cardHm' style='color: #87CEFA;'>"
									+ "<div>站点名称:"+json[i]["dianName"]+"</div>" 
									+"<div>地区:"+json[i]["diQName"]+"</div>" 
									+"<div>MN:"+json[i]["sheBBH"]+"</div>"	                        
									+"</el-card>";
									this.$data.infor.push(infoWindow);
									//var marker = this.createMarker(BMap,pointsUp[i],infor[i],myIcon)//new BMap.Marker(point,{icon:myIcon}) // 创建标注
									//map.addOverlay(marker) // 将标注添加到地图中
									// var circle = new BMap.Circle(pointsUp[i], 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
									// map.addOverlay(circle)
							}
							


						}	
						this.$data.points=pointsUp;
						var convertor = new BMap.Convertor();//坐标转换
						convertor.translate(this.$data.points, 1, 5, this.translateCallback);
						map.centerAndZoom(this.$data.points[0], 18);
						
						map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
						
					//myChart.setOption(option); 
					/* if(data.data.length==1)
						alert("无符合条件的数据。");*/
					}
			  	})
			  
		   //    var point = new BMap.Point(109.49926175379778, 36.60449676862417)
			  // var infoWindow=   "<el-card class='box-cardHm' style='color: #87CEFA;'>"
			  // 			                        + "<div>站点名称:</div>" 
			  // 			                        +"<div>地区:</div>" 
			  // 			                        +"<div>MN:</div>"	                        
			  // 			                        +"</el-card>";
			  
		   //    map.centerAndZoom(point, 13)
			 
		      
		    },
		   
		
		onSubmit(){
			this.$router.replace("/home");
		},
		 TimerMap(){
			 var bmap=this.$data.BMap;
			 var mapp=this.$data.map;
			 var that=this;
			return setTimeout(()=>{
				let path=sessionStorage.getItem('path');
			            if(path!="/home"&&path!=null){
							clearTimeout(this.$data.timeId);
						}else{
							if(sessionStorage.getItem('timeId')=="null")
								sessionStorage.setItem("timeId",timerSite(this.$store));
							this.$data.pointStatus=[];
							var json=that.$store.state.sites;
							this.$data.points=[];
							//bm=new BMap.Map("allmap");
							//convertor=new BMap.Convertor();
							for(var i=0;i<json.length;i++){
								
								if(json[i]["longitude"]!=null&&json[i]["latitude"]!=null)	{
									this.$data.points.push(new bmap.Point(json[i]["longitude"],json[i]["latitude"]));
									this.$data.pointStatus.push(json[i]["status"]);
									var infoWindow=   "<el-card class='box-cardHm' style='color: #87CEFA;'>"
										+ "<div>站点名称:"+json[i]["dianName"]+"</div>" 
										+"<div>地区:"+json[i]["diQName"]+"</div>" 
										+"<div>MN:"+json[i]["sheBBH"]+"</div>"	                        
										+"</el-card>";
										this.$data.infor.push(infoWindow);
										//var marker = this.createMarker(BMap,pointsUp[i],infor[i],myIcon)//new BMap.Marker(point,{icon:myIcon}) // 创建标注
										//map.addOverlay(marker) // 将标注添加到地图中
										// var circle = new BMap.Circle(pointsUp[i], 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
										// map.addOverlay(circle)
								}
									
										          
										          
							}	
							//this.$data.points=pointsUp;
							var convertor = new bmap.Convertor();//坐标转换
							convertor.translate(this.$data.points, 1, 5, this.translateCallback);
							//mapp.centerAndZoom(this.$data.points[0], 18);
							mapp.clearOverlays();
							//mapp.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
								
							
						}
			          	
			          
			        },60000)
		}, 
		
		commandHandler(cmd){
			////console.log(cmd);
			if(cmd=='logout'){
				
				this.$confirm('此操作将注销登陆, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
				          
				            this.getRequest("logout");
							window.sessionStorage.removeItem("user");
							sessionStorage.path=null;
							this.$store.commit('initRoutes',[]);
							this.$store.commit('initSites',[]);
							clearTimeout(this.timeId);							
							sessionStorage.setItem("timeId","null");
							this.$router.replace("/");
							
							
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消操作'
				          });          
				        });
			}else if(cmd=='userinfo'){
				this.$router.push('/sys/syspw');
				
				sessionStorage.setItem("timeId","null")
			}
			else if(cmd=='home'){
				this.$router.push('/home');
				
			}
			else if(cmd=='dataDis'){
				var that=this;
				if(this.$store.state.sites.length==0){
					this.getRequest('/data/real/getDianIfor').then(resp => {
						var json=resp.data;					
						if(json.length==0){
							this.$message({
							  type: 'info',//success/warning/info/error/;
							  message: "无符合条件的数据。"
							});
							//alert("无符合条件的数据。");								
						}else{
							
							that.$data.sites=resp.data;
							that.$store.commit('initSites',resp.data)
							//that.$store.state.sites=resp.data;
							//console.log(that.$store.state.sites);
						}
					});
				}
				else
				this.$data.sites=this.$store.state.sites;
				
				this.$router.push('/data/datadis');
				//location.reload();
				
			}
			
		}
		
	}
}
</script>

<style>
	.mapcss{
		width:'100%';
		height:this.$data.mapHeight;
		marginBottom: '10px'
	}
	.homeRouterView{
		margin-top: 10px;
	}
	.homeWelcome {
		text-align: center;
		/* font-size: 30px; */
		/* font-family: 华文行楷; */
		/* color: #87CEFA; */
		
		 padding-top: 10px; 
	}
	.homeHeader{
		background-color:#0098db;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding:0px 15px;
		height: 80px !important;;
		box-sizing: border-box;
	}
	.homeHeader .title {
			font-size: 30px;
			font-family: 微软雅黑;
			color: #ffffff
	}
	.homeHeader .userInfo{
		cursor: pointer;
	}
	
	.title img{
		width: 60px;
		height: 40px;
		vertical-align:middle;		
		margin-right: 10px;
	}
	.box-cardHm {
		text-align: left;
		width: 400px;
		
		font-family: 微软雅黑;
		/* color: #87CEFA; */
	}
	.text {
	font-size: 18px;
	color: #87CEFA;
	}
	
	.item {
	padding: 5px 0;
	}
	.aside{
		 text-align: left; 
		 margin-left: -10px;
	}
	.twoitem{
		margin-left: -40px;
	}
</style>